module.exports = __webpack_public_path__ + "img/40.09e47077.jpg";